import {Component, Input} from '@angular/core';
import { DOWNLOAD_API_PATH } from '../../../services/http/utils/httpSettings';
import { I18nFileFrontDto } from '../../../domain/i18n/i18nFileFrontDto';
import {CurrentEnvironmentConfigService} from '../../../services/common/currentEnvironmentConfig.service';
import {IziviaUriOpenerService} from '../../../services/common/iziviaUriOpener.service';

@Component({
    selector: 'faq-file[faqFile]',
    templateUrl: './faqFile.component.html',
    styleUrls: ['./faqFile.component.scss']
})
export class FaqFileComponent {

    @Input() faqFile: I18nFileFrontDto;

    constructor(
        private readonly currentEnvironmentConfigService: CurrentEnvironmentConfigService,
        private readonly urlOpenerService: IziviaUriOpenerService
    ) {
    }

    download(fileId: string): void {
        this.currentEnvironmentConfigService.getCurrentDocumentBaseUrl()
            .subscribe(baseUrl => this.urlOpenerService.open(baseUrl + DOWNLOAD_API_PATH + fileId));
    }
}
